export default __webpack_public_path__ + "static/media/googleplay_jp_badge_web.06f1179a.png";